import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/shared/services/toast.service';
import { lastValueFrom } from 'rxjs';
import { BaseResponseDTO } from 'src/app/core/models/app.models';
import { VendorDto, VendorModel } from 'src/app/modules/authentication/components/models/autentication-dto.models';
import { AuthenticationActions, IconType, VendorType } from 'src/app/modules/authentication/components/models/authentication-actions.enum';
import { OtpComponent } from 'src/app/modules/authentication/components/otp/otp.component';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { FormUtils } from 'src/app/shared/helpers/utils.helper';
import { User } from 'src/app/shared/models/app.models';
import { ApiService } from 'src/app/shared/services/api.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { FormValidationService } from 'src/app/shared/services/form-validation.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { SharedOTPDialogService } from 'src/app/shared/services/shared-otp-dialog.service';
import { UserService } from 'src/app/shared/services/user.service';
import en from 'src/assets/i18n/en';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
    translations = en;
    user : User | null;
    vendorForm: FormGroup;
    passwordForm: FormGroup;
    vendor : VendorDto | null = null;
    Countries: any[] = [];
    vendorType = VendorType;

  constructor(
    private _router: Router,
    private _activeRoute : ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: HttpClient,
    private _dialogService: DialogService,
    private _loaderService: LoaderService,
    private _userService: UserService,
    private formValidationService: FormValidationService ,
    private otpDialogService: SharedOTPDialogService,
    private toastService: ToastService
  ) { }

  async ngOnInit() {
    this.user = this._userService.user;

    console.log("user : ", this.user);

    const apiService = new ApiService(this._http);  
    apiService.loadAllLookups().then(() => {
      this.Countries = apiService.countries || [];  
      // this.AttachmentsMaster = apiService.preQualifications.filter(criteria => 
      //   criteria.values == null || criteria.values.length < 0
      // );

    }).catch(error => {
      console.error('Failed to load lookups:', error);
    });



    if (this.user?.Id) {
      await this.GetProfile();
      // this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]);
    }


    const mobile =  FormUtils.extractMobileDetails(this.vendor?.mobile || '');

 


    this.vendorForm = new FormGroup({
      email : new FormControl(this.vendor?.email ? this.vendor?.email : '', Validators.required),
      vendorName : new FormControl(this.vendor?.vendorName ? this.vendor?.vendorName : this.vendor?.firstName + ' ' + this.vendor?.lastName, Validators.required),
      contactPerson: new FormControl(
        this.vendor?.contactPerson
          ? (this.vendor?.contactPerson[0] as any)?.Name || ((this.vendor?.contactPerson[0] as any)?.firstName || '') + ' ' + ((this.vendor?.contactPerson[0] as any)?.lastName || '')
          : '',
        Validators.required
      ),
      country : new FormControl({ value: this.vendor?.countryRegionIdPrimary ? this.vendor?.countryRegionIdPrimary : '', disabled: true }),
      // New mobile field added here
      Mobile: new FormControl(mobile.mobileNumber ?   mobile.mobileNumber  : '', [Validators.required, Validators.pattern('^\\+?[0-9]\\d{1,14}$')]),
      MobileCode: new FormControl( mobile.mobileCode || '+974'),
      
    });
    


    this.passwordForm  = this._formBuilder.group({
      newPassword : new FormControl('', Validators.required),
      confirmNewPassword : new FormControl('', Validators.required)
    }, { validator: this.ConfirmAndPassMatchesAndStrength.bind(this) });

  }

  private ConfirmAndPassMatchesAndStrength(frm: FormGroup) {
    
    const passwordControl = frm.controls['newPassword'];
    const confirmPasswordControl = frm.controls['confirmNewPassword'];


    passwordControl.setErrors(null);

    const password = passwordControl.value;
    const confirmPassword = confirmPasswordControl.value;



    const isValid = password.length >= 8 &&
                    /[A-Z]/.test(password) &&
                    /[a-z]/.test(password) &&
                    /[0-9]/.test(password) &&
                    /[^a-zA-Z0-9]/.test(password);

    if (!isValid) {
        this.formValidationService.setCustomError(frm.controls['newPassword'], this.translations.common.PasswordStrength);
        return false;
    }

    if (password !== confirmPassword) {
        this.formValidationService.setCustomError(frm.controls['newPassword'], this.translations.common.ConfirmedPassdontMatch);
        return false;
    }

    return true;
}

  private createApiService(): ApiService {
    const apiService = new ApiService(this._http);
    apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
    return apiService;
  }
  async GetProfile(){
    let apiService = this.createApiService();
    // var payload = null;
    // var keyValuePair = {id: this.serviceId};
    let req$= apiService.get(AppConstants.CONTROLLERS.VENDOR, AppConstants.ACTIONS.GetVendorDetails, true, environment.APIs_PREFIX );
    await lastValueFrom(req$).then((data:any) => {
      this.vendor = data.data || null;
      console.log("vendor" , this.vendor);
    },
    (err: HttpErrorResponse) => {
      console.log(err);
      this.vendor = null;
    });
  }

  onSubmitVendor(){
    

 

    let isMobileValid = this.vendorForm.controls['Mobile'].valid;
    let isMobileCodeValid = this.vendorForm.controls['MobileCode'].valid;
    
    if (!isMobileValid) {
      console.log("Mobile field is invalid. Errors:", this.vendorForm.controls['Mobile'].errors);
    }
    console.log("Mobile code valid:", isMobileCodeValid);
    
    if(isMobileValid && isMobileCodeValid) {
     
       const mobileCode = this.vendorForm.controls['MobileCode'].value + ' ';
       const mobile = this.vendorForm.controls['Mobile'].value;
       const newmobile  = mobileCode + mobile; 
          this.otpDialogService.showDialog(
            'OTP Verification',
            'Please enter the OTP',
            AuthenticationActions.ChangeMobile,
            this.onOtpSuccess.bind(this), // Method to call on success
           { NewMobile : newmobile } 
          );


      // this.SubmitVendorProfile().then((result) => {
      //   if (result.isSuccess) {

      //   } else {
      //     console.log('First function returned false, stopping execution');
      //   }
      // }).catch((error) => {
      //   console.error('Error in first function:', error);
      // });
    }
    else {
      this.markFormGroupTouched(this.vendorForm);
    }
  }

  

  onOtpSuccess(data: any) {
    console.log('OTP verification succeeded!', data);
    // Handle the passed data (e.g., use data.userId or data.email)
  }
  
//   private mapToBackendVendor(vendorModel: VendorModel): VendorModel {
//     return {
//         vendorName : this.vendorForm.controls['vendorName'].value,
//         Country : this.vendorForm.controls['country'].value,
//         contactPerson: this.vendorForm.get('contacts')?.value.map(contact => ({
//             FirstName: contact.firstName || null,
//             LastName: contact.lastName || null,
//             Title: contact.title || null,
//             Email: contact.email || null,
//             LandlineNumber: contact.landlineNumber || null,
//             MobileNumber: contact.mobileNumber || null
//         })) || [],
      

//     };
// }

  public SubmitVendorProfile() : Promise<BaseResponseDTO> {
    
    if (!this.vendor) {
      return Promise.reject(new Error('Vendor data not loaded'));
    }

    console.log("registeration from: " , this.vendorForm);
    console.log("this.registrationForm.getRawValue() " , this.vendorForm.getRawValue());
    const apiService = this.createApiService();

    let newVendor = {
      email : this.vendorForm.controls['email'].value,
      vendorName : this.vendorForm.controls['vendorName'].value,
      contactPerson : this.vendorForm.controls['contactPerson'].value,
      country : this.vendorForm.controls['country'].value,
      vendorID : this.vendor.vendorID,
    }

    console.log("newVendor " , newVendor);

    return new Promise((resolve, reject) => {

        this.firePostVendor(apiService,newVendor)
        .then((result: any) => {
          let response: BaseResponseDTO = result;

          if (response?.isSuccess){
            this._dialogService.showDialog("Profile" , "Updated Successfully",IconType.Success);
          }
          else{
            this._loaderService.hideLoader();
            this._dialogService.showDialog("Profile" , response.errorMessageEn,IconType.Error);
          }
          resolve(response);

        }).catch((err: HttpErrorResponse) => {
            this._loaderService.hideLoader();
            this._dialogService.showDialog("Profile" , "something Went Wrong",IconType.Error);
        }).finally(() =>{
            this._loaderService.hideLoader();
        });

    });

  }


  onSubmitVendorPassword(){
    let result = this.passwordForm.valid;

    console.log("form valid :" , result)

    if(result) {
      let password = this.passwordForm.controls['newPassword'].value
      const isValid = password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /[0-9]/.test(password) &&
      /[^a-zA-Z0-9]/.test(password);

      if (!isValid) {
        
        this.toastService.error('Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character');
        return;
      }

      if(this.passwordForm.controls['newPassword'].value != this.passwordForm.controls["confirmNewPassword"].value){
        this.toastService.error('new assword and confirm new password are differrent');
        return;
      }

      this.otpDialogService.showDialog(
        'OTP Verification',
        'Please enter the OTP',
        AuthenticationActions.ChangePassword,
        this.onOtpSuccess.bind(this), // Method to call on success
        {Password : password }
      );


      // this.SubmitVendorPassword().then((result) => {
      //   if (result.isSuccess) {

      //   } else {
      //     console.log('First function returned false, stopping execution');
      //   }
      // }).catch((error) => {
      //   console.error('Error in first function:', error);
      // });
    }
    else {
      this.markFormGroupTouched(this.passwordForm);
    }
  }

  public SubmitVendorPassword() : Promise<BaseResponseDTO> {

    if (!this.vendor) {
      return Promise.reject(new Error('Vendor data not loaded'));
    }

    console.log("registeration from: " , this.vendorForm);
    console.log("this.registrationForm.getRawValue() " , this.vendorForm.getRawValue());
    const apiService = this.createApiService();

    let newVendor = {
      password: this.passwordForm.controls['newPassword'].value,
      vendorID : this.vendor.vendorID,
    }

    console.log("newVendor " , newVendor);

    return new Promise((resolve, reject) => {

        this.firePutVendorPass(apiService,newVendor)
        .then((result: any) => {

          console.log("response : ", result);

          let response: BaseResponseDTO = result;

          if (response?.isSuccess){
            
           this._dialogService.showDialog("Profile" , "Updated Successfully",IconType.Success);
          }
          else{
            this._dialogService.showDialog("Profile" , response.errorMessageEn,IconType.Error);
          }
          resolve(response);

        }).catch((err: HttpErrorResponse) => {
            this._loaderService.hideLoader();
            this._dialogService.showDialog("Profile" , "something Went Wrong",IconType.Error);
        }).finally(() =>{
            this._loaderService.hideLoader();
        });

    });

  }

  private firePostVendor(apiService: ApiService, payload: any) {
    let req$ = apiService.post(AppConstants.CONTROLLERS.VENDOR, AppConstants.ACTIONS.UpdateVendor, true, environment.APIs_PREFIX, payload);
    return lastValueFrom(req$);
  }

  private firePutVendorPass(apiService: ApiService, payload: any) {
    let req$ = apiService.put(AppConstants.CONTROLLERS.VENDOR, AppConstants.ACTIONS.UpdateVendorPassword, true, environment.APIs_PREFIX, payload);
    return lastValueFrom(req$);
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
